export const PUBLICATIONS = {
    manuscript: 'Manuscript',
    presentation: 'Presentation',
    congress: 'Poster',
    journal: 'Abstract',
    dataOnFile: 'Data on File',
} as const

export type PublicationType = (typeof PUBLICATIONS)[keyof typeof PUBLICATIONS]
